import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getGeneralAPI, getGeneralKbnAPI, getGeneralDetailAPI, addGeneralAPI, updateGeneralAPI } from './api';
import {
  filterGeneral,
  filterGeneralSuccess,
  filterGeneralFailure,
  getKbnGeneral,
  getKbnGeneralSuccess,
  getDetailGeneral,
  getDetailGeneralSuccess,
  getDetailGeneralFailure,
  registerGeneral,
  registerGeneralSuccess,
  registerGeneralFailure,
  updateGeneral,
  updateGeneralSuccess,
  updateGeneralFailure,
} from './slice';
import {
  SearchGeneralMasterRequest,
  DetailGeneralMasterRequest,
  UpdateGeneralMasterRequest,
} from 'api-types/src/types/general-master';

function* fetchGeneralMaster({ payload }: { payload: SearchGeneralMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getGeneralAPI, trimQueryData(payload));
    yield put(filterGeneralSuccess(response.data));
  } catch (error) {
    yield put(filterGeneralFailure());
  }
}

function* fetchGeneralMasterKbn() {
  try {
    const response: ResponseGenerator = yield call(getGeneralKbnAPI);
    yield put(getKbnGeneralSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

function* fetchGeneralDetail({ payload }: { payload: DetailGeneralMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getGeneralDetailAPI, payload);
    yield put(getDetailGeneralSuccess(response.data));
  } catch (error: any) {
    yield put(getDetailGeneralFailure({ message: error?.message }));
  }
}

function* registerGeneralSaga({ payload }: { payload: UpdateGeneralMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(addGeneralAPI, payload);
    yield put(registerGeneralSuccess(response));
  } catch (error: any) {
    yield put(registerGeneralFailure({ message: error?.message }));
  }
}

function* updateGeneralSaga({ payload }: { payload: UpdateGeneralMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(updateGeneralAPI, payload);
    yield put(updateGeneralSuccess(response));
  } catch (error: any) {
    yield put(updateGeneralFailure({ message: error?.message }));
  }
}

function* watchGeneralMaster() {
  yield takeLatest(filterGeneral, fetchGeneralMaster);
  yield takeLatest(getKbnGeneral, fetchGeneralMasterKbn);
  yield takeLatest(getDetailGeneral, fetchGeneralDetail);
  yield takeLatest(registerGeneral, registerGeneralSaga);
  yield takeLatest(updateGeneral, updateGeneralSaga);
}

export default watchGeneralMaster;
